import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

import authReducer from "./features/auth/authSlice";
import loginReducer from "./container/Login/reducer/slice";
import usersReducer from "./container/Users/reducer/slice";
import userDetailsReducer from "./container/Dashboard/reducer/slice";
import finalStatusListReducer from "./container/AddNewReward/reducer/slice";
import getCaseReducer from "./container/viewDetails/reducer/slice";
import abhaAddressReducer from "./container/Register/reducer/abhaAadhar/slice";

const appReducer = combineReducers({
  login: loginReducer,
  abhaAddress: abhaAddressReducer,
  auth: authReducer,

  users: usersReducer,

  userDetails: userDetailsReducer,
  finalStatusList: finalStatusListReducer,
  getCase: getCaseReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "FLUSH_STORE") {
    storage.removeItem("persist:root");
    storage.removeItem("persist:dashboard");
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

const persistConfig = {
  key: "root",
  storage: storage,
  whitelist: ["hierarchy"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  //!instead of rootReducer you can pass persistedReducer to persist the data
  reducer: rootReducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ["response/download/fulfilled"],
        // Ignore these field paths in all actions
        ignoredActionPaths: ["payload"],
        // Ignore these paths in the state
        ignoredPaths: ["responses.downloadExcel"],
      },
    }),
});
// const persistor = persistStore(store);
//!removed persistor from redux code you can export the same

export default { store };
